import api from './axios';

export async function get_all_donors(page = 1,searchTerm = '', searchKeyType = '') {
  try {
    const res = await api.get('/donors/', {
      params: { page,searchTerm, searchKeyType }
    });
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function get_donor_by_id(donor_id) {
  try {
    let res = await api.get(`/donors/${donor_id}`);
    res = res.data;
    return res;
  } catch (err) {
    throw err;
  }
}

export async function add_donor(donor) {
  
  try {
    const res = await api.post('/donors/add', donor);
    return res.data;
  } catch (err) {

    if (err.response) {
      throw {
        message: err.response.data.error,
        status: err.response.status
      };
    }
    throw { message: "Unknown error", status: 500 };
  }
}

export async function update_donor(donor) {
  try {
    const res = await api.put(`/donors/update/${donor.donor_id}`, donor);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function delete_donor(donor_id) {
  try {
    const res = await api.delete(`/donors/delete/${donor_id}`);
    return res.data;
  } catch (err) {
    throw err;
  }
}
